<template>
  <div class="footer">
    <div class="contact">
      <p  class="contact-us">Contact US</p>
      <p class='contact-us-detail'>int@ehsy.com</p>
      <p class='contact-us-detail'> Sunplus Building 4th floor, 1077 Zuchongzhi Rd, Pudong New District, Shanghai 201203</p>
      <p class='contact-us-detail'>(0086)18930217882</p>
    </div>
    <div class="wechat">
      <img class='code-img' src="@/assets/images/home/erweima27.png" alt="">
      <p class='follow-us'>Follow us on WeChat</p>
    </div>
  </div>
</template>

<script>
  export default {
    name: "footerContent"
  }
</script>

<style scoped>

  .footer{
    border-top: 12px solid #eaeaea;
    padding:30px 70px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .footer .contact{
    text-align: left;
  }

  .footer .contact .contact-us{
    font-size: 15px;
    font-weight: bold;
  }
  .footer .contact .contact-us-detail{
    font-size: 14px;
    font-weight: normal;
    color: #666;
  }

  .footer .wechat{
    width: 120px;
    text-align: center;
  }

  .footer .wechat .code-img{
    width: 100%;
  }
  .footer .wechat .follow-us{
    font-size: 12px;
  }

</style>



// WEBPACK FOOTER //
// src/components/footer.vue